import { render, staticRenderFns } from "./tab-languages.vue?vue&type=template&id=62f71bd7"
import script from "./tab-languages.vue?vue&type=script&lang=js"
export * from "./tab-languages.vue?vue&type=script&lang=js"
import style0 from "./tab-languages.vue?vue&type=style&index=0&id=62f71bd7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports